module.exports = __webpack_public_path__ + "Estructura_de_datos_frsm.xlsx?dca2ba52edb3c5da1690b31e4afebf69";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/Estructura_de_datos_frsm.xlsx
// module id = 150
// module chunks = 2